import React, { useEffect, useRef } from 'react';
import { useReducedMotion } from './useMotion';

export default function BackgroundVisualization({ sceneRef }) {
  const canvasRef = useRef(null);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    // Leave the readable page intact on devices with no 3D graphics support.
    if (!navigator.gpu && !window.WebGL2RenderingContext) return;
    let cancelled = false;
    let scene;
    const canvas = canvasRef.current;
    const start = async () => {
      try {
        // Keep the renderer out of the initial page/content bundle.
        const { createVisualization } = await import('./visualization/createVisualization');
        if (cancelled) return;
        scene = await createVisualization(canvas, {
          sceneRef,
          reducedMotion,
          saveData: Boolean(navigator.connection?.saveData),
        });
        if (cancelled) scene.dispose();
      } catch (error) {
        canvas.dataset.renderer = 'unavailable';
        // A lost/unsupported graphics device must never break navigation.
        console.warn('The decorative 3D background is unavailable.', error);
      }
    };
    start();
    return () => {
      cancelled = true;
      if (scene) scene.dispose();
    };
  }, [sceneRef, reducedMotion]);

  return <div className="background-visualization" aria-hidden="true">
    <canvas key={reducedMotion ? 'still' : 'animated'} ref={canvasRef} className="background-visualization__canvas" />
  </div>;
}
